export enum GiftCardConfigurationGroupEnum {
  settings = 'Settings'
}
